import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../FieldComponets/Spinner';
import { FullName, getItemFromStorage, handleShowSwalConfirmationOk, userPicUrl } from '../../utils/Helper';
import React from 'react';
import { AdminDetailProfileAction, AdminProfileUpdateAction } from '../../Redux/Action/AuthAction';
import { toast } from 'react-toastify';
// import Spinner from '../Components/FieldComponets/Spinner';
// import { FullName, userPicUrl } from '../utils/Helper';
import Swal from 'sweetalert2';
import { getDateFormat , formatDate , getDateFormatData , getDate } from '../../utils/Helper';

function ProfileInfo() {
    const dispatch = useDispatch<any>();
    const DetailAdminProfile = useSelector((state: any) => state.DetailAdminProfileState);
    const [profile, setProfile]: any = useState({
        fname: '',
        lname: '',
        phone_country_code: '',
        phone_number: '',
    });
    useEffect(() => {
        if (DetailAdminProfile?.data) {
            setProfile({
                fname: DetailAdminProfile?.data?.data?.fname,
                lname: DetailAdminProfile?.data?.data?.lname,
                email: DetailAdminProfile?.data?.data?.email,
                profile_pic: DetailAdminProfile?.data?.data?.profile_pic,
                phone_country_code: DetailAdminProfile?.data?.data?.phone_country_code,
                phone_number: DetailAdminProfile?.data?.data?.phone_number,
            })
        }
    }, [dispatch, DetailAdminProfile?.data]);



    const handleImage = async () => {
        let data = await handleShowSwalConfirmationOk("You want to delete ?", true);
      
        if (data) {
            await dispatch(AdminProfileUpdateAction({}));
            await dispatch(AdminDetailProfileAction({}));
            $('#imageProfile').remove();
            toast.success("Profile Image Deleted Successfully")
        }

    }

    return (
        <div className="col-xl-4">
            {DetailAdminProfile?.loading && <Spinner />}
            <div className="card overflow-hidden">
                <div className="bg-primary bg-soft authpage-banner">
                    <div className="row" style={{ background: '#000' }}>
                        <div className="col-7">
                            <div className="text-light p-3">
                                <h3 className="text-light"> Hello!</h3>
                                <p className='admin-profile'>{FullName(profile.fname, profile.lname)}</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="card-body pt-0">
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="avatar-md profile-user-wid ">


                                {(() => {
                                    if (profile.profile_pic === null) {

                                        return (
                                            <figure><img src={userPicUrl(profile.profile_pic)} alt="" className="img-thumbnail rounded-circle bg-black border border-dark" /></figure>
                                        )
                                    }
                                    else if (profile.profile_pic !== null) {
                                        return (
                                            <>
                                                <button className='w-auto text-danger p-1 bg-transparent border-0' style={{ 'position': 'absolute', 'right': '3px', 'top': '3px' }} onClick={() => handleImage()}> <i className="fa fa-trash" aria-hidden="true"></i></button>

                                                <figure><img src={userPicUrl(profile.profile_pic)} alt="" className="img-thumbnail rounded-circle bg-black border border-dark" /></figure>
                                            </>
                                        )
                                    }
                                })()}

                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-12">
                                    <h5 className="font-size-15">Email: <span className="text-muted mb-0">{profile.email}</span></h5>
                                    <h5 className="font-size-15">Last Update: <span className="text-muted mb-0">{ getDate(DetailAdminProfile?.data?.data?.updated_at)}</span></h5>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default ProfileInfo;